import { APICore } from "./apiCore";

const api = new APICore();

const createSolicitacaoFeedback = (params: {
  usuario_id: number;
  colaboradores_solicitados: number[];
  momento: number;
  temas: number[];
  descricao: string;
}) => {
  return api.create(`/solicitacao-feedback`, params);
};

const getSolicitacaoFeedback = (id: number) => {
  return api.get(`/solicitacao-feedback/${id}`);
}

const deleteSolicitacaoFeedback = (id: number) => {
  return api.delete(`/solicitacao-feedback/${id}`);
}

export { createSolicitacaoFeedback, getSolicitacaoFeedback, deleteSolicitacaoFeedback };
